
<div class="main-grid filter-normal">
  <section class="bread-crumb">
    <div class="flex bet bottom">
      <div class="col-6 pd-0">
        <app-hrm-breadcrumb [items]="itemsBreadcrumb" ></app-hrm-breadcrumb>
      </div>
    </div>
  </section>

  <section class="content pb-0">
    <div class="grid-default" #container>
      <app-list-grid-angular
        (callbackGridReady)="onGridReady($event)"
        [groupDefaultExpanded]="1"
        [listsData]="listsData" [height]="heightGrid"
        (showConfig)="cauhinh()"
        [floatingFilter]="false"
        [idGrid]="'_45dfs'"
        (callback)="rowSelected($event)"
        [columnDefs]="columnDefs"></app-list-grid-angular>
    </div>
  </section>
</div>


<!--<p-dialog header="{{'_Cài đặt cấu hình_' | translate }}" [(visible)]="displaySetting" (onHide)="find()" [modal]="true" [style]="{width: '50vw'}" [maximizable]="true"-->
<!--          [draggable]="false" [resizable]="false" [focusTrap]="false" styleClass="popup-setting">-->
<!--  <app-config-grid-table-form *ngIf="displaySetting && gridKey" [typeConfig]="'TableInfo'"   [gridKey]="gridKey"></app-config-grid-table-form>-->
<!--</p-dialog>-->

